import { AgentResponseDetailDto, AgentTypeDto } from '../../../overmind/actions';
import { AgentResponsesData, AgentResponsesSearchRequest } from './information-search.models';

export interface AgentResponsesState {
  agentTypes: AgentTypeDto[];
  request: AgentResponsesSearchRequest;
  data: AgentResponsesData;
  loadingAgentDetails: boolean;
  agentDetails: AgentResponseDetailDto | undefined;
}

export enum AgentResponsesActionTypes {
  SetAgentTypes = 'SET_AGENT_TYPES',
  SetRequest = 'SET_REQUEST',
  SetData = 'SET_DATA',
  SetLoadingAgentDetails = 'SET_LOADING_AGENT_DETAILS',
  SetAgentDetails = 'SET_AGENT_DETAILS',
}

export type AgentResponsesAction =
  | { type: AgentResponsesActionTypes.SetAgentTypes; payload: AgentTypeDto[] }
  | { type: AgentResponsesActionTypes.SetRequest; payload: AgentResponsesSearchRequest }
  | { type: AgentResponsesActionTypes.SetData; payload: AgentResponsesData }
  | { type: AgentResponsesActionTypes.SetLoadingAgentDetails; payload: boolean }
  | { type: AgentResponsesActionTypes.SetAgentDetails; payload: AgentResponseDetailDto | undefined };

export const initialState: AgentResponsesState = {
  agentTypes: [],
  request: {
    companySlug: '',
    page: 1,
    pageSize: 10,
  },
  data: {
    agentResponses: [],
    totalPages: 0,
    totalCount: 0,
  },
  loadingAgentDetails: false,
  agentDetails: undefined,
};

export function reducer(state: AgentResponsesState, action: AgentResponsesAction): AgentResponsesState {
  switch (action.type) {
    case AgentResponsesActionTypes.SetAgentTypes: {
      return {
        ...state,
        agentTypes: action.payload,
      };
    }

    case AgentResponsesActionTypes.SetRequest: {
      return {
        ...state,
        request: action.payload,
      };
    }

    case AgentResponsesActionTypes.SetData: {
      return {
        ...state,
        data: action.payload,
      };
    }

    case AgentResponsesActionTypes.SetLoadingAgentDetails: {
      return {
        ...state,
        loadingAgentDetails: action.payload,
      };
    }

    case AgentResponsesActionTypes.SetAgentDetails: {
      return {
        ...state,
        agentDetails: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
